/** Why a bulk authorised-signatory invite item was skipped rather than invited. */
export enum BulkInviteSkipReason {
	/** The email already holds the role's other slot, under a different identity (DC-1203). */
	DUPLICATE_SIGNATORY_ON_ROLE = 'DUPLICATE_SIGNATORY_ON_ROLE',
}
